import { BrowserRouter, Routes, Route } from "react-router-dom";
import Landing from "./pages/home/Landing";
import Navbar from "./components/navbar/Navbar";
import Feed from "./components/feed/Feed";
import "./App.css";
import Login from "./pages/login/Login";
import Register from "./pages/register/Register";
import PageNotFound from "./pages/404/PageNotFound";
import Livestreams from "./pages/livestreams/Livestreams";
import SingleFeed from "./components/feed/SingleFeed";
import Codepair from "./pages/codepair/Codepair";
import Doubt from "./components/doubt/Doubt";
import SingleDoubt from "./components/doubt/SingleDoubt";
// import ImageSlider from "./pages/home/ImageSlider";
// import Community from "./pages/home/Community";
export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/feed" element={<Feed />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/livestreams" element={<Livestreams />} />
          <Route path="/livestreams/room/:roomID" element={<Livestreams />} />
          <Route path="*" element={<PageNotFound />} />
          <Route path="/feed/:url" element={<SingleFeed />} />
          <Route path="/doubt/:url" element={<SingleDoubt />} />

          <Route path="/doubt" element={<Doubt />} />
          <Route path="/codepair" element={<Codepair />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}
